<template>
    <a class="panel panel--bordered" :href="url">
        <div class="small semi">{{ title }}</div>
        <div class="panel__actions">
            <span class="tw-text-black tw-cursor-pointer tw-no-underline tw-group tw-relative tw-inline-block tw-pb-2.5 tw-align-top tw-text-sm lg:tw-text-base ">
                <span class="tw-bg-brand-orange tw-absolute tw-left-0 tw-right-0 tw-bottom-0 tw-block tw-h-0.5 tw-w-full tw-transition-size tw-duration-300 tw-ease-in-out lg:group-hover:tw-h-1"></span>
                View
            </span>

            <div class="panel__status">
                <span v-if="!isAvailable" class="panel__complete bg--white">
                    <svg class="icon text--orange"><use xlink:href="#lock" /></svg>
                </span>
                <span class="panel__complete" :class="{ 'bg--orange' : isMember }">
                    <svg class="icon">
                        <use xlink:href="#tick" />
                    </svg>
                </span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "CommitteeCard",

    props: {
        title: {
            type: String,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
        committees: {
            type: Array,
            default: null,
        },
        membershipLevel: {
            type: Array,
            default: null,
        },
        currentUser: {
            type: Object,
            default: null,
        },

    },
    data() {
        return {

        };
    },
    computed: {
       isMember () {
            return !!this.currentUser.committees.filter(element => this.committees.indexOf(element) !== -1).length;
        },
        isAvailable () {
            if (this.isMember) {
                return true;
            } else {
                if (this.membershipLevel.length && this.currentUser.membershipLevel.length) {
                    return this.currentUser.membershipLevel.filter(element => this.membershipLevel.indexOf(element) !== -1).length;
                }
                return false;
            }
        }
    }
};
</script>